import * as microsoftTeams from '@microsoft/teams-js';

import { vxm } from '@/store';

import { IToken } from '@/entities/token';

export function acquireTokenWrapper(): Promise<string | undefined> {
    return new Promise((resolve, reject) => {
        if (process.env.NODE_ENV === 'development') {
            // TODO: for development mode -> resolve with msal
            // !!!! SET YOUR OWN TOKEN !!!!!
            const token = 'token';
            vxm.app.setUserInformation(token);
            resolve(token);
        }
        microsoftTeams.authentication.getAuthToken({
            successCallback: (res: string) => {
                vxm.app.setUserInformation(res);
                resolve(res);
            },
            failureCallback: (error: string) => {
                reject(error);
            },
        });
    });
}

export function parseJwt(token: string): IToken {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
}
